import { lazy, Suspense } from "react";
import SendCampaignInvites from "../pages/OrganizerCampain/SendCampaignInvites.jsx";
import OutgoingInvites from "../pages/OrganizerCampain/OutgoingInvites.jsx";

// -------- Pages -------- //
const DashboardOrg = lazy(() => import("../pages/Dashboard"));
// -----------CampaignPage ------------------/

const CreateCampaignPage = lazy(
  () => import("../pages/OrganizerCampain/CreateCampaignPage.jsx"),
);
const EventCampaignList = lazy(
  () => import("../pages/OrganizerCampain/EventCampaignList.jsx"),
);
const Campaigns = lazy(
  () => import("../pages/OrganizerCampain/CampaignsList.jsx"),
);
const CampaignDetail = lazy(
  () => import("../pages/OrganizerCampain/CampaignDetail.jsx"),
);
const UpdateCampaign = lazy(
  () => import("../pages/OrganizerCampain/UpdateCampaign"),
);
const AllApplications = lazy(
  () => import("../pages/OrganizerCampain/AllApplications.jsx"),
);
const CampaignApplications = lazy(
  () => import("../pages/OrganizerCampain/CampaignApplications.jsx"),
);
const CampaignApplicationDetail = lazy(
  () => import("../pages/OrganizerCampain/CampaignApplicationDetail.jsx"),
);
const CampaignApplicationReview = lazy(
  () => import("../pages/OrganizerCampain/CampaignApplicationReview.jsx"),
);
const CampaignApplicationAccepted = lazy(
  () => import("../pages/OrganizerCampain/CampaignApplicationAccepted.jsx"),
);
const CampaignRequestsPage = lazy(
  () => import("../pages/OrganizerCampain/CampaignRequestsPage .jsx"),
);
const CampaignViewRequest = lazy(
  () => import("../pages/OrganizerCampain/CampaignViewRequest.jsx"),
);
const CampaignInvitesList = lazy(
  () => import("../pages/OrganizerCampain/CampaignInvitesList.jsx"),
);
const CreateCustomPack = lazy(
  () => import("../pages/OrganizerCampain/CreateCustomPack.jsx"),
);
const PayoutPage = lazy(
  () => import("../pages/payout/OrganizerPayoutsPage.jsx"),
);
const EventPayoutHistory = lazy(
  () => import("../pages/payout/EventPayoutHistory.jsx"),
);

// -------- Events Management Pages -------- //
const EventDivision = lazy(
  () => import("../pages/eventsmanagement/EventDivision"),
);

const Transactions = lazy(() => import("../pages/transactions/Transaction"));

//--Organizer Event Booking---//
const AllBookings = lazy(() => import("../pages/eventbooking/AllBookings"));
const AllMovieBookings = lazy(
  () => import("../pages/moviebookings/AllBookings.jsx"),
);
const AddOnlineEvent = lazy(
  () => import("../pages/eventsmanagement/AddOnlineEventOrg"),
);
const AddSeatingEvent = lazy(
  () => import("../pages/eventsmanagement/addSeatsEvent"),
);
const BookingPage = lazy(() => import("../pages/eventsmanagement/BookingPage"));
const AddVenueEvent = lazy(
  () => import("../pages/eventsmanagement/AddVenueEventOrg"),
);
const updateEvent = lazy(() => import("../pages/eventsmanagement/UpdateEvent"));
const VenueEventsOrg = lazy(
  () => import("../pages/eventsmanagement/VenueEventsOrg"),
);

const OnlineEventsOrgs = lazy(
  () => import("../pages/eventsmanagement/OnlineEventsOrgs"),
);
const Events = lazy(() => import("../pages/eventsmanagement/Events"));
const PreRegistrationManager = lazy(() => import("../pages/eventsmanagement/PreRegistrationManager.jsx"));

const OrganizerBookingDetail = lazy(
  () => import("../pages/eventsmanagement/OrganizerBookingDetail.jsx"),
);

// -------- Orders/Venues/Payout Pages -------- //
const Order = lazy(() => import("../pages/Orders/Order"));
const PayoutRequest = lazy(() => import("../pages/Orders/PayoutRequest"));
const Venues = lazy(() => import("../pages/Orders/Venues"));

// -------- Campaign Pages -------- //
const Reports = lazy(() => import("../pages/campaign/Reports"));
const Reviews = lazy(() => import("../pages/campaign/Reviews"));

// -------- User Management Pages -------- //
const Users = lazy(() => import("../pages/users/Users"));

// -------- Movie Management Pages -------- //
const AddMovie = lazy(() => import("../pages/moviemanagementOrg/AddMovie"));
const AllotTheater = lazy(
  () => import("../pages/moviemanagementOrg/AllotTheater"),
);
const Movies = lazy(() => import("../pages/moviemanagementOrg/Movies"));

const updateMovie = lazy(
  () => import("../pages/moviemanagementOrg/UpdateMovie"),
);

const MovieHistory = lazy(
  () => import("../pages/moviemanagementOrg/BookingPage.jsx"),
);
const ManageMovieTicket = lazy(
  () => import("../pages/moviemanagementOrg/ManageMovie.jsx"),
);

// -------- Support Ticket Pages -------- //
const AddTicketOrg = lazy(
  () => import("../pages/SupportTicketOrg/AddTicketOrg"),
);
const AllTicketsOrg = lazy(
  () => import("../pages/SupportTicketOrg/AllTicketsOrg"),
);
const Tickets = lazy(() => import("../pages/eventsmanagement/Tickets"));

const AddEventTickets = lazy(
  () => import("../component/tickets/AddEventTicket"),
);

const AddMovieTickets = lazy(
  () => import("../component/movieTickets/AddTickets.jsx"),
);

const MovieTicketUpdate = lazy(
  () => import("../component/movieTickets/UpdateTickets.jsx"),
);

const EventTicketUpdate = lazy(
  () => import("../component/tickets/UpdateEventTicket.jsx"),
);
//--PWA Scanner Settings---//
const ScannerListpage = lazy(() => import("../pages/ScannerListPage.jsx"));
const PwaScanner = lazy(() => import("../pages/pwaScanner/PwaScanner"));
// -------- Edit Profile Pages -------- //
const EditProfileOrgs = lazy(
  () => import("../pages/EditProfileOrg/EditProfileOrgs"),
);
const ChangePasswordOrg = lazy(
  () => import("../pages/EditProfileOrg/ChangePasswordOrg"),
);
const AddTheater = lazy(() => import("../pages/moviemanagementOrg/AddTheater"));
const OrganizerCommitment = lazy(
  () => import("../pages/OrganizerCommitmentsPage"),
);
const OrganizerCommitmentDetail = lazy(
  () => import("../pages/OrganizerCommitmentDetailsPage"),
);
const OfferList = lazy(() => import("../pages/offerList"));
const sponsorMatching = lazy(() => import("../pages/SponsorMatchmaking.jsx"));
const WithdrawRequest = lazy(() => import("../pages/withdraw/WithdrawRequest"));
const MyWithdraws = lazy(() => import("../pages/withdraw/MyWithdraws"));
const serviceFeeOverview = lazy(
  () => import("../pages/OrganizerServiceFeeOverview.jsx"),
);
const renderRoute = (Component) => (
  <Suspense
    fallback={
      <div className="flex space-x-2 justify-center items-center bg-white h-screen dark:invert">
        <span className="sr-only">Loading...</span>
        <div className="h-8 w-8 bg-black rounded-full animate-bounce [animation-delay:-0.3s]"></div>
        <div className="h-8 w-8 bg-black rounded-full animate-bounce [animation-delay:-0.15s]"></div>
        <div className="h-8 w-8 bg-black rounded-full animate-bounce"></div>
      </div>
    }
  >
    <Component />
  </Suspense>
);

const organizerNavigationRoutes = [
  { path: "", element: renderRoute(DashboardOrg) },
  { path: "offers", element: renderRoute(OfferList) },
  { path: "events", element: renderRoute(Events) },
  { path: "events/:eventId/preregistration", element: renderRoute(PreRegistrationManager) },
  { path: "addevent", element: renderRoute(EventDivision) },
  { path: "updateEvent", element: renderRoute(updateEvent) },
  { path: "addonlineevent", element: renderRoute(AddOnlineEvent) },
  { path: "addvenueevent", element: renderRoute(AddVenueEvent) },
  { path: "sponsors", element: renderRoute(sponsorMatching) },
  { path: "addSeatingEvent", element: renderRoute(AddSeatingEvent) },
  { path: "allvenueEvents", element: renderRoute(VenueEventsOrg) },
  { path: "allonlineEvents", element: renderRoute(OnlineEventsOrgs) },
  { path: "order", element: renderRoute(Order) },
  { path: "events/bookings", element: renderRoute(BookingPage) },
  { path: "events/bookings/detail", element: renderRoute(OrganizerBookingDetail) },
  { path: "ticket/:type/:id/:slug/:country", element: renderRoute(Tickets) },
  { path: "feeoverview", element: renderRoute(serviceFeeOverview) },
  {
    path: "addTicket/:type/:id/:country",
    element: renderRoute(AddEventTickets),
  },
  {
    path: "updateTicket/:ticket_id/:id/:type/:country",
    element: renderRoute(EventTicketUpdate),
  },
  { path: "commitments", element: renderRoute(OrganizerCommitment) },
  { path: "commitments/:id", element: renderRoute(OrganizerCommitmentDetail) },
  { path: "addmovie", element: renderRoute(AddMovie) },
  { path: "updateMovie", element: renderRoute(updateMovie) },
  { path: "allotTheater", element: renderRoute(AllotTheater) },
  { path: "movies", element: renderRoute(Movies) },
  { path: "movies/moviehistory", element: renderRoute(MovieHistory) },
  {
    path: "manageMovieTicket/:id/:slug/:country",
    element: renderRoute(ManageMovieTicket),
  },
  {
    path: "addMovieTicket/:id/:country",
    element: renderRoute(AddMovieTickets),
  },
  { path: "Scanner-list", element: renderRoute(ScannerListpage) },
  {
    path: "updateMovieTicket/:id/:country/:ticket_id",
    element: renderRoute(MovieTicketUpdate),
  },
  {
    path: "payouts",
    element: renderRoute(PayoutPage),
  },
  {
    path: "payouts/event/:type/:eventRef",
    element: renderRoute(EventPayoutHistory),
  },
  { path: "payoutrequest", element: renderRoute(PayoutRequest) },
  { path: "reviews", element: renderRoute(Reviews) },
  { path: "reports", element: renderRoute(Reports) },
  { path: "users", element: renderRoute(Users) },
  { path: "venues", element: renderRoute(Venues) },
  { path: "addSupportTicket", element: renderRoute(AddTicketOrg) },
  { path: "allTickets", element: renderRoute(AllTicketsOrg) },
  { path: "editProfile", element: renderRoute(EditProfileOrgs) },
  { path: "changePassword", element: renderRoute(ChangePasswordOrg) },
  { path: "pwascanner", element: renderRoute(PwaScanner) },
  { path: "allbooking", element: renderRoute(AllBookings) },
  { path: "allMoviebooking", element: renderRoute(AllMovieBookings) },
  { path: "transactions", element: renderRoute(Transactions) },
  { path: "mywithdraw", element: renderRoute(MyWithdraws) },
  { path: "mywithdrawform", element: renderRoute(WithdrawRequest) },
  { path: "addtheater", element: renderRoute(AddTheater) },
  {
    path: "event-campaigns",
    element: renderRoute(EventCampaignList),
  },
  {
    path: "CreateCampaign/:eventId",
    element: renderRoute(CreateCampaignPage),
  },
  {
    path: "campaigns",
    element: renderRoute(Campaigns),
  },
  { path: "View-campaign/:campaignId", element: renderRoute(CampaignDetail) },
  { path: "update-campaign/:campaignId", element: renderRoute(UpdateCampaign) },
  {
    path: "campaigns/:campaignId/applications",
    element: renderRoute(CampaignApplications),
  },
  {
    path: "campaigns/:campaignId/application/:requestId",
    element: renderRoute(CampaignApplicationDetail),
  },
  {
    path: "campaigns/:campaignId/applications/:requestId/review",
    element: renderRoute(CampaignApplicationReview),
  },
  {
    path: "campaigns/:campaignId/applications/:requestId/accepted",
    element: renderRoute(CampaignApplicationAccepted),
  },
  { path: "campaigns/all-applications", element: renderRoute(AllApplications) },
  {
    path: "create-custom-pack",
    element: renderRoute(CreateCustomPack),
  },
  {
    path: "CampaignViewRequest",
    element: renderRoute(CampaignViewRequest),
  } /* for dummy data  */,
  // { path: "CampaignViewRequest/:campaignId/:requestId", element: renderRoute(CampaignViewRequest) }  /*for real data */
  { path: "campaigns/invites-list", element: renderRoute(OutgoingInvites) },
  {
    path: "campaigns/:campaignId/invites",
    element: renderRoute(OutgoingInvites),
  },
  {
    path: "campaigns/:campaignId/invite",
    element: renderRoute(SendCampaignInvites),
  },
];

export default organizerNavigationRoutes;
